import React, { Component } from 'react'
import { checkTranslation, translate } from '../../utils/useful'
import TLink from '../TLink'

class AdminModule extends Component {

    state = {
        open: false
    }

    componentDidMount() {
    }

    render() {

        let data = this.props.data
        let link = this.props.settings?.baseUrl + '/' + (data.key ?? data._id)
        let name = (data.title ?? data.name) ?? translate("No Name")
        return (
            <button className={" w-100 h-100 service-box"} onClick={() => this.props.onClick(data.key ?? data._id) }>
                <div className="w-100 m-0 p-0 flexcc pt-3">
                    <div className="m-0 p-0 w-100 h-100 flexcc " to={link}>
                        <img className=" m-0 p-0" src={data.icon ?? '/assets/icons/applets/general/play-games.png'} alt={data.title} height={70} />
                    </div>
                </div>


                <div className="mx-3 pt-3  pb-4 service-box-content text-center">
                    <div to={link}><h3 className="font-bold text-normal m-0">{checkTranslation(name) }</h3></div>
                    <div to={link}><p className="service-box-desc text-smaller">{checkTranslation(data.description ?? 'This is a collection, You can use collections to do save, find and report on data')}</p></div>
                </div>

            </button>
        )
    }
}

export default AdminModule
